export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    buttonShadow: () => 'none',
    raisedShadow: () => 'none',
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    blob: p => p.secondaryLight,
    blobGradientStart: p => p.primaryLight,
    blobGradientEnd: p => p.primaryDark,
    background: p => p.tertiaryDark,
    backgroundColor: p => p.tertiaryDark
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    blob: p => p.tertiaryDark,
    blobGradientStart: p => p.primaryLight,
    blobGradientEnd: p => p.primaryDark,
    background: p => p.tertiaryLight,
    backgroundColor: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    blob: p => p.secondaryDark,
    blobGradientStart: p => p.primaryLight,
    blobGradientEnd: p => p.primaryDark,
    background: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight
  }
}
